import { FilterType, freeFormHubFilterKeys } from '../../types';
import { FilterWrapper } from '../filterWrapper/filterWrapper';
import { useFreeFormHubInputValidator } from '../../hooks/inputValidator';
import { useFreeFormHubFilterState } from '../../hooks/useUrlFilterState';
import { getUnitLabelForUnitSystem, TemperatureCode } from '@icommerce/units';
import type { UnitSystem } from '@igus/kopla-domain';
import { getIcommerceUnitSystemName } from '@hub/bearing-hub/common/useUnitSystem/useUnitSystem';

type TemperatureSectionProps = {
  unitSystem: UnitSystem;
};

export const TemperatureSection = ({ unitSystem }: TemperatureSectionProps) => {
  const rangeValidator = useFreeFormHubInputValidator(FilterType.RANGE);
  const [minValue, setMinValue] = useFreeFormHubFilterState<FilterType.RANGE>(
    freeFormHubFilterKeys.TEMPERATURE_RANGE_MIN,
    rangeValidator
  );
  const [maxValue, setMaxValue] = useFreeFormHubFilterState<FilterType.RANGE>(
    freeFormHubFilterKeys.TEMPERATURE_RANGE_MAX,
    rangeValidator
  );

  return (
    <div className="mt-8">
      <FilterWrapper
        type={FilterType.RANGE}
        props={{
          key: `${freeFormHubFilterKeys.TEMPERATURE_RANGE_MIN}_${freeFormHubFilterKeys.TEMPERATURE_RANGE_MAX}`,
          id: `${freeFormHubFilterKeys.TEMPERATURE_RANGE_MIN}_${freeFormHubFilterKeys.TEMPERATURE_RANGE_MAX}`,
          min: null,
          max: null,
          unit: getUnitLabelForUnitSystem(TemperatureCode.CELSIUS, getIcommerceUnitSystemName(unitSystem)),
          values: [minValue, maxValue],
          onChange: (newValues: [number, number]) => {
            const [min, max] = newValues;
            if (min !== null && typeof min !== 'undefined') {
              setMinValue(min);
            } else if (min === null) {
              setMinValue(undefined);
            }
            if (max !== null && typeof max !== 'undefined') {
              setMaxValue(max);
            } else if (max === null) {
              setMaxValue(undefined);
            }
          },
        }}
      />
    </div>
  );
};
